"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NanoContractActionType = void 0;
/**
 * Copyright (c) Hathor Labs and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
let NanoContractActionType = exports.NanoContractActionType = /*#__PURE__*/function (NanoContractActionType) {
  NanoContractActionType["DEPOSIT"] = "deposit";
  NanoContractActionType["WITHDRAWAL"] = "withdrawal";
  return NanoContractActionType;
}({}); // Arguments for blueprint methods